"use client";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { switchAllLocaleAction } from "../fetchers/switch-locale";
import { ChevronDown } from "lucide-react";

export interface LanguageSwitcherProps {
  languages: {
    code: string;
    name: string;
    flagCode: string;
    fieldsNumber?: number;
    filledFields?: number;
  }[];
  currentLanguage: string;
  switchLanguage?: (language: string) => void;
  label?: string;
}

export function LanguageSwitcher({
  languages,
  currentLanguage,
  switchLanguage,
  label,
}: LanguageSwitcherProps) {
  return (
    <div className="flex w-full flex-col gap-2">
      {label && (
        <label className="text-sm font-medium text-[#344054]">{label}</label>
      )}
      <div className="relative w-full min-w-0">
        <select
          onChange={(e) => {
            switchLanguage
              ? switchLanguage(e.target.value)
              : switchAllLocaleAction(e.target.value);
          }}
          value={currentLanguage}
          className="lang-switcher w-full min-w-0 rounded-md border-0 border-gray-300 p-0 pe-8 text-sm font-semibold lg:text-xl"
        >
          {languages.map((lang) => {
            return (
              <option key={lang.code} value={lang.code} className="text-sm">
                {lang.name}
              </option>
            );
          })}
        </select>
        <span className="pointer-events-none absolute end-2 top-1/2 -translate-y-1/2">
          <ChevronDown className="size-5 lg:size-6" />
        </span>
      </div>
    </div>
  );
}
